/**
 * Волна 40: усиление великанов (отчет 38). Признаки факторного A/B —
 * isPreW40*Player в utils/bots/abTestGates, режим харнесса SIM_W40_FLAGS. Гипотезы,
 * не давшие эффекта (V2, V4, все пять у гоблинов), из кода убраны.
 *
 * Числа — стартовые оценки гипотез, а не подобраны прогонами.
 */

// --- Великаны

// V3. Применение армии: к R10 армия вдвое больше соперников, а урона вдвое меньше.
// С этого размера великан идет в бой от меньшего превосходства, а полученный им
// урон весит как у обычного отряда
export const W40_GIANTS_ATTACK_MIN_SIZE = 20;
export const W40_GIANTS_ATTACK_ENGAGE_RATIO = 1.2;
export const W40_GIANTS_ATTACK_RECEIVED_DAMAGE_WEIGHT = 1;
// С этого размера (равен порогу удержания на казарме) великан тянется к
// ближайшему чужому городу: надбавка за каждую клетку ближе дальности тяги.
// Потолок 30 — не перебивает захват (100), сопоставим с обороной городов (30)
export const W40_GIANTS_ATTACK_PULL_MIN_SIZE = 24;
export const W40_GIANTS_ATTACK_PULL_RANGE = 10;
export const W40_GIANTS_ATTACK_PULL_PER_CELL = 3;
